'use client'

import Image from 'next/image'
import { memo } from 'react'

const TechStack = memo(function TechStack() {
  const techIcons = [
    {
      name: 'Python',
      icon: '/logos/python.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
      url: 'https://www.python.org/',
    },
    {
      name: 'Go',
      icon: '/logos/go.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg',
      url: 'https://go.dev/',
    },
    {
      name: 'React',
      icon: '/logos/react.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
      url: 'https://react.dev/',
    },
    {
      name: 'Kubernetes',
      icon: '/logos/kubernetes.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg',
      url: 'https://kubernetes.io/',
    },
    {
      name: 'TypeScript',
      icon: '/logos/typescript.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
      url: 'https://www.typescriptlang.org/',
    },
    {
      name: 'Next.js',
      icon: '/logos/nextjs.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg',
      url: 'https://nextjs.org/',
    },
    {
      name: 'PostgreSQL',
      icon: '/logos/postgresql.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
      url: 'https://www.postgresql.org/',
    },
    {
      name: 'Docker',
      icon: '/logos/docker.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',
      url: 'https://www.docker.com/',
    },
    {
      name: 'AWS',
      icon: '/logos/aws.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original.svg',
      url: 'https://aws.amazon.com/',
    },
    {
      name: 'MongoDB',
      icon: '/logos/mongodb.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
      url: 'https://www.mongodb.com/',
    },
    {
      name: 'GraphQL',
      icon: '/logos/graphql.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg',
      url: 'https://graphql.org/',
    },
    {
      name: 'Redis',
      icon: '/logos/redis.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg',
      url: 'https://redis.io/',
    },
    {
      name: 'Rust',
      icon: '/logos/rust.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rust/rust-plain.svg',
      url: 'https://www.rust-lang.org/',
    },
    {
      name: 'Terraform',
      icon: '/logos/terraform.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg',
      url: 'https://www.terraform.io/',
    },
    {
      name: 'Node.js',
      icon: '/logos/nodejs.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
      url: 'https://nodejs.org/',
    },
    {
      name: 'Vercel',
      icon: '/logos/vercel.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg',
      url: 'https://vercel.com/',
    },
    {
      name: 'Swift',
      icon: '/logos/swift.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg',
      url: 'https://www.swift.org/',
    },
    {
      name: 'TensorFlow',
      icon: '/logos/tensorflow.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg',
      url: 'https://www.tensorflow.org/',
    },
    {
      name: 'OpenAI',
      icon: '/logos/openai.svg',
      fallback: 'https://cdn.simpleicons.org/openai/ffffff',
      url: 'https://openai.com/',
    },
    {
      name: 'Claude (Anthropic)',
      icon: '/logos/anthropic.svg',
      fallback: 'https://cdn.simpleicons.org/anthropic/ffffff',
      url: 'https://www.anthropic.com/',
    },
    {
      name: 'Gemini (Google)',
      icon: '/logos/gemini.svg',
      fallback: 'https://cdn.simpleicons.org/googlegemini/ffffff',
      url: 'https://gemini.google.com/',
    },
    {
      name: 'Android',
      icon: '/logos/android.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg',
      url: 'https://www.android.com/',
    },
    {
      name: 'Kotlin',
      icon: '/logos/kotlin.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg',
      url: 'https://kotlinlang.org/',
    },
    {
      name: 'Java',
      icon: '/logos/java.svg',
      fallback: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',
      url: 'https://www.java.com/',
    },
  ]

  // Duplicate items twice for seamless infinite scrolling (reduced from 4x)
  const duplicatedIcons = [...techIcons, ...techIcons]

  return (
    <section className="tech-stack-section">
      <div className="container">
        <div className="tech-stack-scroll-wrapper">
          <div className="tech-stack-scroll">
            {duplicatedIcons.map((tech, index) => (
              <a key={index} href={tech.url} target="_blank" rel="noopener noreferrer" className="tech-icon" title={tech.name} aria-label={tech.name}>
                <Image
                  src={tech.icon}
                  alt={tech.name}
                  className="tech-icon-img"
                  loading="lazy"
                  width={64}
                  height={64}
                  sizes="64px"
                  quality={75}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
})

export default TechStack
